export default "__VITE_ASSET__CbIYg4sN__"